export default function hasCollar() {
    // color with 50% chance
    return Math.random() > 0.5;
}
